module.exports = __webpack_public_path__ + "static/media/Cats Eyes 10_SPANSKA-mixdown.25cbc546.mp3";